import api, { cardeal } from './api';

export class ResgateParcialService {
  ObterDadosPrevidenciariosResgate = async (
    matricula,
    plano,
    percentualIndividual = 0,
    percentualAdicional = 0,
    percentualEventual = 0,
    percentualPortabilidadeAberta = 0
  ) => {
    const response = await cardeal.get('ObterDadosPrevidenciariosResgate', {
      params: {
        matricula,
        plano,
        percentualIndividual,
        percentualAdicional,
        percentualEventual,
        percentualPortabilidadeAberta,
      },
    });
    return response.data;
  };

  ObterHistoricoResgateParcial = async (matricula, plano) => {
    const response = await cardeal.get('ObterHistoricoResgateParcial', {
      params: { matricula, plano },
    });
    return response.data;
  };

  ObterDadosEmprestimoResgate = async (matricula) => {
    const response = await cardeal.get('ObterDadosEmprestimoResgate', {
      params: { matricula },
    });
    return response.data;
  };

  InserirDadosRegistroOpcaoResgate = async (params) => {
    const responseRegistroSaque = await cardeal.post(
      'InserirDadosRegistroOpcaoResgate',
      {
        matricula: Number(params.matricula),
        plano: Number(params.plano),
        autor: params.autor,
        percentualResgatadoContaIndividual:
          params.percentualResgatadoContaIndividual,
        percentualResgatadoContaAdicional:
          params.percentualResgatadoContaAdicional,
        percentualResgatadoContaEventual:
          params.percentualResgatadoContaEventual,
        percentualResgatadoContaPortabilidadeAberta:
          params.percentualResgatadoContaPortabilidadeAberta,
        numeroParcelas: params.numeroParcelas,
        codigoBanco: params.codigoBanco,
        agencia: params.agencia,
        contaCorrente: params.contaCorrente,
        regimeTributacao: params.regimeTributacao,
        percentualResgatado: params.percentualResgatado,
        percentualRemanescenteSaqueVista:
          params.percentualRemanescenteSaqueVista,
      }
    );
    return responseRegistroSaque.data[0];
  };

  CancelarRegistroOpcaoResgate = async (protocolo, matricula) => {
    const responseRegistroSaque = await cardeal.post(
      'CancelarRegistroOpcaoResgate',
      {
        matricula,
        protocolo,
      }
    );
    return responseRegistroSaque.data[0];
  };

  GerarDetalhamentoResgateParcialPDF = async (params) => {
    const responseRegistroSaque = await api.post(
      'GerarDetalhamentoResgateParcialPDF',
      {
        ...params,
      }
    );
    return responseRegistroSaque.data;
  };

  GerarComprovanteResgateParcialPDF = async (params) => {
    const responseRegistroSaque = await api.post(
      'GerarComprovanteResgateParcialPDF',
      {
        ...params,
      }
    );
    return responseRegistroSaque.data;
  };

  GerarMemoriaCalculoResgateParcialPDF = async ({
    matricula,
    anoMes,
    token,
  }) => {
    const responseRegistroSaque = await api.get('ObterMemoriaCalculoResgate', {
      params: { matricula, anoMes, token },
      responseType: 'arraybuffer',
    });
    return responseRegistroSaque.data;
  };

  GerarSimulacaoResgateParcialPDF = async (params) => {
    const responseRegistroSaque = await api.post(
      'GerarSimulacaoResgateParcialPDF',
      {
        ...params,
      }
    );
    return responseRegistroSaque.data;
  };
}
